import $ from 'jquery';

import widgetFactory from '../widgetFactory';

const widgetName = 'choiceForm',
  className = 'js-' + widgetName,
  classNameItem = 'js-' + widgetName + '-item';

const widget = widgetFactory(widgetName, {
  options: {},

  _create: function () {
    this._super(className);
    this._attachEvents();
  },

  _attachEvents: function () {
    var self = this;

    this.element.on('change', 'input[type=radio]', function () {
      const $element = $(this);
      let itemId;

      if ($element.closest('.' + classNameItem, self.element).length === 0) {
        itemId = $element.attr('id');
        $('.' + classNameItem, self.element).addClass('is-hidden');
        $('[data-for="' + itemId + '"]', self.element).removeClass('is-hidden');
      }
    });
  },
});

export default widget;
